import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CanvasService } from '../../services/canvas.service';

@Component({
    selector: 'app-layers-panel',
    imports: [CommonModule],
    templateUrl: './layers-panel.component.html',
    styleUrl: './layers-panel.component.scss'
})
export class LayersPanelComponent {
    private canvasService = inject(CanvasService);
    readonly objects = this.canvasService.activeObjects;
    readonly selectedIds = this.canvasService.selectedIds;

    readonly sortedObjects = computed(() =>
        [...this.objects()].sort((a, b) => b.zIndex - a.zIndex)
    );

    readonly hasSelection = computed(() => this.selectedIds().length > 0);

    isSelected(id: string): boolean {
        return this.selectedIds().includes(id);
    }

    selectLayer(id: string, event: MouseEvent): void {
        event.stopPropagation();
        const addToSelection = event.shiftKey || event.metaKey || event.ctrlKey;
        this.canvasService.selectObject(id, addToSelection);
    }

    toggleVisibility(id: string, event: MouseEvent): void {
        event.stopPropagation();
        const obj = this.objects().find(o => o.id === id);
        if (obj) {
            this.canvasService.updateObject(id, { visible: !obj.visible });
        }
    }

    toggleLock(id: string, event: MouseEvent): void {
        event.stopPropagation();
        const obj = this.objects().find(o => o.id === id);
        if (obj) {
            this.canvasService.updateObject(id, { locked: !obj.locked });
        }
    }

    duplicateLayer(): void {
        this.canvasService.duplicateSelected();
    }

    deleteLayer(): void {
        const ids = this.selectedIds();
        if (ids.length > 0) {
            this.canvasService.deleteObjects(ids);
        }
    }

    moveUp(): void {
        const ids = this.selectedIds();
        if (ids.length > 0) {
            this.canvasService.bringToFront(ids);
        }
    }

    moveDown(): void {
        const ids = this.selectedIds();
        if (ids.length > 0) {
            this.canvasService.sendToBack(ids);
        }
    }

    getIcon(type: string): string {
        const icons: Record<string, string> = {
            rectangle: '▭',
            circle: '⭕',
            ellipse: '⬯',
            line: '⟋',
            polygon: '⬟',
            text: 'T',
            image: '🖼️',
            svg: '📄',
            group: '📁',
            frame: '⬜'
        };
        return icons[type] || '▢';
    }
}
